import * as React from 'react';
import { compose } from 'redux';

import Navbar from '../../Navbar';
import { SignupHelpButton } from '../../NavbarHelpButton';

import { useTranslation } from '@shopee-user/platform';
import {
  useShouldHideBack,
  withUserWebView,
  WithUserWebViewProps,
} from '@shopee-user/with-web-view';
import { useSignupByOtpOneCredentialOptionalFlowEvent } from '@tob/pages/signup-by-otp-one-credential-optional/flow-event';

type Props = WithUserWebViewProps;

function _Header({ webViewNavigateBack }: Props) {
  const I18n = useTranslation();
  const shouldHideBack = useShouldHideBack();
  const { trackEvent } = useSignupByOtpOneCredentialOptionalFlowEvent();
  return (
    <Navbar
      title={I18n.t('label_auth_signup')}
      onClickBack={() => {
        webViewNavigateBack();
      }}
      rightContent={
        <SignupHelpButton
          text={I18n.t('label_auth_help')}
          onClick={() => {
            trackEvent('onSignupSignupHelpClick');
          }}
        />
      }
      shouldHideBack={shouldHideBack}
    />
  );
}

const Header = compose<React.ComponentType<{}>>(withUserWebView({}))(_Header);

export { Header };
